// extracted by mini-css-extract-plugin
export default {"tableBanner":"TableBanner_tableBanner__dKfKn","bannerRed":"TableBanner_bannerRed__nPdrz","bannerBlue":"TableBanner_bannerBlue__yY02L"};